/**
 * Fertilization site mapping shared by the Freeze and Freeze V2 apps.
 *
 * The site selector works in raw numeric site ids (the `sId` query param),
 * but some backend queries expect the CRM storage-location UUID instead.
 * These helpers translate between the two.
 *
 * This lives outside `pages/freeze` so both apps use one table — a duplicated
 * copy of this mapping is what caused bug 33389 to reappear in Freeze V2.
 */

export const MAIN_FARM_ID = '8E229164-4C97-DE11-8DE3-0019D18A6560';
export const MAC_TO_MAIN_FARM_ID = 'DE21BE7F-0B58-EA11-81B1-005056975FE0';
export const MO_MISSOURI_ID = '7AF40E6B-4C97-DE11-8DE3-0019D18A6560';
export const TXP_TO_TX_ID = 'D0729841-C0D4-E911-8193-005056975FE0';
export const INCOMING_TO_WAC_ID = 'B023F072-728E-E711-80F8-005056975FE0';

/**
 * Maps a raw fertilization site id to the storage-location site UUID expected
 * by `GET_FREEZE_STORAGE_LOCATIONS($fertilizationSiteId: UUID!)`.
 *
 * Unmapped ids are returned unchanged — sites whose id is already a UUID pass
 * straight through.
 */
export const getFertilizationSiteId = (
  rawFertilizationSiteId: string | null,
) => {
  switch (rawFertilizationSiteId) {
    case '1': //'Main Farm':
    case '3': //'MO - D5':
    case '4': //TOGU':
      return MAIN_FARM_ID;
    case '6': //'MAC to Main Farm':
    case '8': //'MAC to TXP':
      return MAC_TO_MAIN_FARM_ID;
    case '2': //'MO - Missouri':
      return MO_MISSOURI_ID;
    case '10': //'TXP to TX':
    case '11': //'CR to CA':
      return TXP_TO_TX_ID;
    case '9': //'Incoming to WAC':
      return INCOMING_TO_WAC_ID;
    case '5': //'TXP - Texas Panhandle Lab:
      return TXP_TO_TX_ID;
    default:
      return rawFertilizationSiteId;
  }
};

/**
 * Maps a raw fertilization site id for the freeze validation call.
 *
 * Deliberately narrower than {@link getFertilizationSiteId}: only the
 * shipping-route sites are remapped here.
 */
export const getValidateFreezeSiteId = (
  rawFertilizationSiteId: string | null,
) => {
  switch (rawFertilizationSiteId) {
    case '9': //'Incoming to WAC':
      return INCOMING_TO_WAC_ID;
    case '10': //'TXP to TX':
    case '11': //'CR to CA':
      return TXP_TO_TX_ID;
    default:
      return rawFertilizationSiteId;
  }
};
